<template lang="pug">
  form(id="payment-form" v-if="payment !== null")
    div.md-form-group(:class="{'invalid':errors.has('name')}")
      input.md-input(
      type="text"
      name="name"
      v-model="payment.name"
      v-validate="'required'"
      data-vv-as="name"
      :disabled="loading"
      ref="paymentName"
      )
      label Name
      span.form-error-msg(v-show="errors.has('name')") {{ errors.first('name') }}

    div.md-form-group(:class="{'invalid':errors.has('type')}")
      select.md-input(
      v-model="payment.type"
      :disabled="loading"
      )
        option(v-for="type in types" :key="type.type" v-bind:value="type.type") {{ type.name }}
      label Mode

    div.md-form-group(v-if='filterMode' :class="{'invalid':errors.has('preset_amount')}")
      input.md-input(
      type="text"
      name="preset_amount"
      v-model="payment.preset_amount"
      v-validate="'decimal'"
      data-vv-as="preset amount"
      :disabled="loading"
      )
      label Preset amount
      span.form-error-msg(v-show="errors.has('preset_amount')") {{ errors.first('preset_amount') }}

    div.md-form-group.p-t-0
      label.multiselect-label Applicable outlets
      multiselect(
      name="outlets"
      v-model="payment.outlets"
      :options="outletList"
      placeholder="Type to search"
      label="name"
      :multiple="true"
      :loading="outletList.length === 0"
      :disabled="loading"
      :clear-on-select="false"
      :close-on-select="false"
      :hide-selected="true"
      track-by="id"
      )
      span.md-input-msg Leave empty if applicable to all outlets.

    div.md-form-group(v-if="this.payment.type != 0 && this.payment.type != 1")
      label Options
      div.form-group
        p
          label.md-switch.has-value
            input(
            type="checkbox"
            name="require_reference"
            v-model="payment.require_reference"
            :disabled="loading"
            )
            i.indigo
            | Require reference number
        
        p
          label.md-switch.has-value
            input(
            type="checkbox"
            name="require_drawer_kick"
            v-model="payment.require_drawer_kick"
            :disabled="loading"
            )
            i.indigo
            | Require drawer kick
</template>

<script>
import FormMixin from './form-mixin';
import types from './create-payment-types';

export default {
    mixins: [FormMixin],
    props: {
        payment: {
            type: Object,
            required: true,
            default: () => ({
                name: '',
                type: 0,
                preset_amount: null,
                require_reference: false,
                require_drawer_kick: false,
                source: null,
                outlets: [],
            }),
        },
    },

    data() {
        return {
            types: types,
            payment_id: [{ id: 0 }, { id: 1 }, { id: 2 }, { id: 4 }],
        };
    },

    computed: {
        filterMode() {
            let p = this.payment.type;
            let t = this.payment_id;
            let filter = t.find(t => t.id === p);

            if (filter) {
                return false;
            }

            return true;
        },
    },

    methods: {
        mapPaymentValue() {
            let payment = _.pick(this.payment, [
                'id',
                'name',
                'type',
                'preset_amount',
                'require_reference',
                'require_drawer_kick',
            ]);

            return Object.assign(payment, {
                outlets: this.payment.outlets.map(obj => obj.id),
            });
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/setting/payment/settings-payment-form.vue